var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.propClass,on:{"click":function($event){return _vm.doAction()}}},[(_vm.propIcon)?_c('i',{class:_vm.propIcon}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.propLabel))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2524d106","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 866
// module chunks = 0